module.exports = __webpack_public_path__ + "static/img/1.b3419c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-1/1.jpg
// module id = HxVX
// module chunks = 0